
import { defineComponent, watch, PropType, useContext, ref } from '@nuxtjs/composition-api'
import CatalogWishlistButton from './CatalogWishlistButton.vue'
import CatalogEmotionImage from './CatalogEmotionImage.vue'

export default defineComponent({
  name: 'CatalogItems',
  components: {
    CatalogWishlistButton,
    CatalogEmotionImage,
  },
  props: {
    filteredItems: {
      type: Array as PropType<any[]>,
      required: true,
    },
    numberOfActiveItems: {
      type: Number,
      required: true,
    },
    pageName: {
      type: String,
      required: true,
    },
    country: {
      type: String,
      required: true,
    },
    wishlistItems: {
      type: Array as PropType<string[]>,
      required: true,
    },
    imagesHost: {
      type: String,
      required: true,
    },
    activeFilterColor: {
      type: String,
      required: false,
      default: '',
    },
    changeItemColor: {
      type: Function as PropType<(colorIdx: number, refIdx: number) => void>,
      required: true,
    },
    addToWishlist: {
      type: Function as PropType<(slug: string) => void>,
      required: true,
    },
    removeFromWishlist: {
      type: Function as PropType<(slug: string) => void>,
      required: true,
    },
  },
  setup(props) {
    const { app } = useContext()
    const localePath = app.localePath
    const { i18n } = app
    const loader = ref(true)

    /* watch number of active items. If Number = 0, loader = true. start timer */
    watch(
      () => props.numberOfActiveItems,
      (newVal) => {
        if (newVal === 0) {
          loader.value = true
          setTimeout(() => {
            loader.value = false
          }, 3000)
        }
      }
    )

    return { localePath, i18n, loader }
  },
})
